const what = '[data-interaction="hover-expand"]';
const oncls = 'interaction-active';
const triggerClickEvent = 'click';
const triggerOpenEvent = 'mouseenter';
const triggerCloseEvent = 'mouseleave';
let lock = false;
const { forEachElement } = require('../common/utils/dom');
const isMatchedBreakpoint = require('../common/utils/isMatchedBreakpoint');

function toggle(element, isOpenEvent) {
  const relation = element.getAttribute('data-interaction-relation');
  let dependant;
  const toggler = element.querySelector('[data-interaction-toggler]');
  if (relation === 'sibling') {
    // eslint-disable-next-line prefer-destructuring
    dependant = $(element).siblings('[data-interaction-dependant]')[0];
  } else if (relation === 'child') {
    dependant = element.querySelector('[data-interaction-dependant]');
  } else if (relation === 'any') {
    const targetValue = element.getAttribute('data-interaction-target');
    dependant = document.querySelector(
      `[data-interaction-dependant][data-interaction-target=${targetValue}]`
    );
  }

  if (dependant) {
    if (isOpenEvent) {
      setOpen(element, dependant, toggler);
    } else {
      setClose(element, dependant, toggler);
    }
  }
}

function init() {
  $('body').on(`${triggerOpenEvent} ${triggerCloseEvent}`, what, (e) => {
    const isFocusDesktop = isMatchedBreakpoint.matches('bp_1025', 'min-width');
    if (!isFocusDesktop) return;
    if (e.type === triggerCloseEvent) {
      tempLock();
    }
    const element = e.target.closest(what);
    const isOpenEvent = e.type === triggerOpenEvent;
    toggle(element, isOpenEvent);
  });

  $('body').on(
    `${triggerClickEvent}`,
    `${what} [data-interaction-toggler="true"]`,
    (e) => {
      e.preventDefault(); // this prevents link href="#" to work on menu headers
      if (!lock) {
        const element = e.target.closest(what);
        const content = element.querySelector('.interaction--expand');
        const isOpenEvent = !content.classList.contains(oncls);
        toggle(element, isOpenEvent);
      }
    }
  );
}

function tempLock() {
  lock = true;
  setTimeout(() => {
    lock = false;
  }, 200);
}

function removeActiveFromSiblingGroups(newActiveGroup) {
  const parent = newActiveGroup.closest('.expand-elements-wrapper');
  const siblingActiveElms = parent.querySelectorAll(`.${oncls}`);

  forEachElement(siblingActiveElms, (i) => {
    i.classList.remove(oncls);
  });
}

function setOpen(item, dependant, toggler) {
  // we will calculate the height on the firstChild, since
  // current item will have no height if max-height is 0 (default)
  let height = 0;

  if (!dependant.classList.contains(oncls)) {
    removeActiveFromSiblingGroups(item);

    if (dependant.children.length > 0) {
      height = 0;
      forEachElement(dependant.children, (child) => {
        height += $(child).outerHeight(true);
      });
    } else {
      height = dependant.scrollHeight;
    }
    height += 10;
    height = `${height}px`;
  }

  dependant.style.setProperty('--max-h', height);
  dependant.classList.add(oncls);
  toggler.classList.add(oncls);
}

function setClose(item, dependant, toggler) {
  dependant.style.setProperty('--max-h', 0);
  dependant.classList.remove(oncls);
  toggler.classList.remove(oncls);
}

function destroy() {
  $('body').off(triggerOpenEvent);
  $('body').off(triggerCloseEvent);
}

module.exports = {
  init,
  setOpen,
  setClose,
  destroy,
};
